module.exports = __webpack_public_path__ + "img/qrcode-qiye.39d2dc01.png";